import React from 'react';
import { STEPS } from './constants';
import './index.scss';

const StepsIndicator = ({ currentStep, onStepClick, didCompleteWizard, visitedSteps }) => {
  return (
    <div className="steps-indicator">
      {STEPS.map((step, idx) => {
        const Icon = step.icon;
        return (
          <div
            key={step.key} disabled={!(didCompleteWizard || visitedSteps.includes(idx))} onClick={() => (didCompleteWizard || visitedSteps.includes(idx)) && onStepClick(idx)}
            className={`step-item${currentStep === idx ? ' active' : ''}`}
          >
            <div className="step-icon">
              <Icon size={18} />
            </div>
            <span className="step-label">{step.label}</span>
            <div className="step-dot-col">
              <div className={`step-dot${currentStep === idx ? ' active' : ''}`} />
              {idx < STEPS.length - 1 && <div className="step-line" />}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StepsIndicator;
